module.exports = __webpack_public_path__ + "components/panel/check-yeti/static/check-yeti--sp-7f4fbf7b6a0ca1d9321e9e47b5c3e4ff.jpg";